import { gql } from 'graphql-request'

export const GET_PROMOTION_CODE_DETAIL = gql`
  query PromotionCode($promotionId: Float!) {
    promotion(id: $promotionId) {
      promotionCode {
        type
        buyCoinConditionValue
        buyCoinCondition
        paymentChannels
        benefitValue
        coin {
          id
          name
        }
        channels {
          name
          totalCount
          totalUsedCount
        }
        couponType
        id
        codesFilePath
        codesFileName
        exportedCouponFilePath
      }
      id
      name
      description
      userTerm
      startPublishedAt
      endPublishedAt
      publishedType
      userType
      usageLimitPerUser
      isUsageLimitPerUser
      usageLimit
      isUsageLimit
      usageDay
      status
      users {
        id
      }
      isActive
      isEditable
      usersFileName
      usersFilePath
      createdAt
      updatedAt
      deletedAt
      businessId
      generateCouponStatus
      isFirstTopUp
      lastRequest {
        id
        status
        action
        createdBy {
          avatarImgPath
          displayName
        }
        createdAt
      }
    }
  }
`
